import React from "react"

import { Element, Image } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import { Maybe } from "types/Maybe"
import { PrismicImageType } from "types/__generated__/gatsby-graphql"
import { useTheme } from "src/legacy/utils"

interface OwnProps {
  bgColor: Maybe<string>
  data: Maybe<PrismicImageType>
}

type ImageProps = OwnProps

const WideHeroImage: React.FC<ImageProps> = ({
  bgColor,
  data,
}): React.ReactElement | null => {
  if (!data?.url || !data?.alt) return null

  const { height, width } = data?.dimensions || {}

  const { sizes } = useTheme()

  return (
    <Element bg={bgColor || "white"} mb={["35px", "85px"]}>
      <Grid gridTemplateColumns={["repeat(12, 1fr)"]} maxWidth={sizes.maxWidth}>
        {data.url && data.alt ? (
          <Element
            paddingTop={["30", "55", "85"]}
            gridColumnEnd={[12]}
            gridColumnStart={[2]}
          >
            <Image
              aspectRatio={`${width} / ${height}`}
              display="block"
              imageData={data}
              maxWidth="100%"
              width={["559px", "688px", "847px", "1193px"]}
            />
          </Element>
        ) : null}
      </Grid>
    </Element>
  )
}

export default WideHeroImage
